<div class="new-incident-container" [class.fullscreen]="isFullscreen$ | async">
	<form [formGroup]="incidentForm" class="form au-forms">
		<au-cmms-entity-name
			[editMode]="true"
			[disablePreview]="true"
			[autofocusEnabled]="true"
			namePreviewClasses="m-b-sxs"
			(controlReady)="addChildControl('name', $event)"
		></au-cmms-entity-name>

		<div class="m-b-xs">
			<cmms-locations-section
				[locationsInputList]="incidentForm.value?.locations"
				(controlReady)="addChildControl('locations', $event)"
				[isRequired]="true"
			></cmms-locations-section>
		</div>

		<div class="priority-and-category">
			<cmms-priority-level
				class="priority"
				(controlReady)="addChildControl('priority', $event)"
			></cmms-priority-level>

			<cmms-entity-category
				class="category"
				(controlReady)="addChildControl('category', $event)"
			></cmms-entity-category>
		</div>

		<div class="assignee-section m-b-xs">
			<cmms-assignee-and-approver
				(assigneeControlReady)="addChildControl('assignee', $event)"
				(approverControlReady)="addChildControl('approver', $event)"
			></cmms-assignee-and-approver>
		</div>

		<div class="m-b-m">
			<cmms-date-picker
				(dateTimeChanged)="incidentForm.controls.deadline.setValue($event)"
				(controlReady)="addChildControl('deadline', $event)"
				label="{{ 'due_date' | translate }}"
				placeholderText="{{ 'choose_date' | translate }}"
				[restrictPastSelections]="true"
			/>
		</div>

		<div class="m-b-m">
			<cmms-date-picker
				(dateTimeChanged)="occurredAtChanged($event)"
				(controlReady)="addChildControl('occurredAt', $event)"
				label="{{ 'occurred_at' | translate }}"
				placeholderText="{{ 'choose_date' | translate }}"
			></cmms-date-picker>
		</div>

		<div class="m-b-m">
			<cmms-labels-section (controlReady)="addChildControl('labels', $event)" />
		</div>

		<div class="description m-b-m">
			<cmms-description
				(controlReady)="addChildControl('description', $event)"
			></cmms-description>
		</div>

		<div class="m-b-m">
			<maintenance-section title="{{ 'maintenance' | translate }}">
				<div class="maintenance-content">
					<div class="maintenance-row">
						<div class="l-control">
							<au-maintenance-selector
								[newMode]="true"
								[selectionType]="'DeviationTypeChoices'"
								(controlReady)="addChildControl('deviationType', $event)"
							/>
						</div>

						<div class="m-control">
							<au-cmms-cost
								labelName="{{ 'cost_of_repair' | translate }}"
								(controlReady)="addChildControl('costOfRepair', $event)"
							/>
						</div>

						<div class="s-control">
							<au-maintenance-selector
								[newMode]="true"
								[selectionType]="'CostAllocationChoices'"
								(controlReady)="addChildControl('costAllocation', $event)"
							/>
						</div>
					</div>

					<div class="maintenance-row">
						<div class="l-control">
							<au-maintenance-selector
								[newMode]="true"
								[selectionType]="'TimeframeChoices'"
								(controlReady)="addChildControl('timeframe', $event)"
							/>
						</div>

						<div class="m-control">
							<au-maintenance-selector
								[newMode]="true"
								[selectionType]="'ConsequenceRatingChoices'"
								(controlReady)="addChildControl('consequenceRating', $event)"
							/>
						</div>

						<div class="s-control">
							<au-maintenance-selector
								[newMode]="true"
								[selectionType]="'RiskLevelChoices'"
								(controlReady)="addChildControl('riskLevel', $event)"
							/>
						</div>
					</div>
				</div>
			</maintenance-section>
		</div>

		<div class="sections">
			<entity-section
				[entityType]="cmmsPages.editWorkOrder"
				(addNewEntityItem)="navigateTo($event)"
				(addExistingEntityItem)="navigateToExist($event)"
				[tableData]="incidentForm?.value?.workOrders || []"
				[tableColumns]="tableConfig"
				(unlink)="unlinkItem($event.data, 'workOrders')"
				(rowSelect)="viewSelected($event)"
			>
			</entity-section>
			<entity-section
				[entityType]="cmmsPages.editRequest"
				(addNewEntityItem)="navigateTo($event)"
				(addExistingEntityItem)="navigateToExist($event)"
				[tableData]="incidentForm?.value?.requests || []"
				[tableColumns]="tableConfig"
				(unlink)="unlinkItem($event.data, 'requests')"
				(rowSelect)="viewSelected($event)"
			>
			</entity-section>
			<assets-section
				(openAssets)="openAssets()"
				(newAsset)="navigateTo($event)"
				(rowSelect)="viewSelected($event.data)"
				(unlink)="unlinkItem($event.data, 'assets')"
				[assets]="incidentForm?.value?.assets"
			>
			</assets-section>
		</div>

		<div class="sections">
			<au-file-loader
				[loadedFiles]="incidentForm?.value?.files"
				[delegateDeleting]="true"
				[cardsView]="true"
				[askDeleting]="false"
				[fullFileLoadData]="true"
				(addExistingFileClicked)="navigateToExist($event)"
				(fullFileLoaded)="fileListChanged($event)"
				(filesDeleted)="filesDeleted($event)"
				[options]="fileLoaderOptions"
				(rowSelect)="viewSelected($event)"
			></au-file-loader>
		</div>
	</form>
</div>
